/* tslint:disable */
/* eslint-disable */
/**
 * Propally SMAUL API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface SmaulLeadRequest
 */
export interface SmaulLeadRequest {
    /**
     * マンション名
     * @type {string}
     * @memberof SmaulLeadRequest
     */
    'mansion_name': string;
    /**
     * 部屋番号
     * @type {string}
     * @memberof SmaulLeadRequest
     */
    'room_number': string;
    /**
     * 苗字
     * @type {string}
     * @memberof SmaulLeadRequest
     */
    'family_name': string;
    /**
     * 名前
     * @type {string}
     * @memberof SmaulLeadRequest
     */
    'first_name': string;
    /**
     * 電話番号
     * @type {string}
     * @memberof SmaulLeadRequest
     */
    'phone_number': string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof SmaulLeadRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface SmaulV1LeadsPost201Response
 */
export interface SmaulV1LeadsPost201Response {
    /**
     * 
     * @type {string}
     * @memberof SmaulV1LeadsPost201Response
     */
    'message'?: string;
}

/**
 * PropallySmaulV1Api - axios parameter creator
 * @export
 */
export const PropallySmaulV1ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary SMAUL 経由の問い合わせ登録
         * @param {SmaulLeadRequest} smaulLeadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smaulV1LeadsPost: async (smaulLeadRequest: SmaulLeadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'smaulLeadRequest' is not null or undefined
            assertParamExists('smaulV1LeadsPost', 'smaulLeadRequest', smaulLeadRequest)
            const localVarPath = `/smaul/v1/leads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(smaulLeadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PropallySmaulV1Api - functional programming interface
 * @export
 */
export const PropallySmaulV1ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PropallySmaulV1ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary SMAUL 経由の問い合わせ登録
         * @param {SmaulLeadRequest} smaulLeadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async smaulV1LeadsPost(smaulLeadRequest: SmaulLeadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmaulV1LeadsPost201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.smaulV1LeadsPost(smaulLeadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropallySmaulV1Api.smaulV1LeadsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PropallySmaulV1Api - factory interface
 * @export
 */
export const PropallySmaulV1ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PropallySmaulV1ApiFp(configuration)
    return {
        /**
         * 
         * @summary SMAUL 経由の問い合わせ登録
         * @param {SmaulLeadRequest} smaulLeadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smaulV1LeadsPost(smaulLeadRequest: SmaulLeadRequest, options?: RawAxiosRequestConfig): AxiosPromise<SmaulV1LeadsPost201Response> {
            return localVarFp.smaulV1LeadsPost(smaulLeadRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PropallySmaulV1Api - object-oriented interface
 * @export
 * @class PropallySmaulV1Api
 * @extends {BaseAPI}
 */
export class PropallySmaulV1Api extends BaseAPI {
    /**
     * 
     * @summary SMAUL 経由の問い合わせ登録
     * @param {SmaulLeadRequest} smaulLeadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallySmaulV1Api
     */
    public smaulV1LeadsPost(smaulLeadRequest: SmaulLeadRequest, options?: RawAxiosRequestConfig) {
        return PropallySmaulV1ApiFp(this.configuration).smaulV1LeadsPost(smaulLeadRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



